import React from 'react';
import { Image } from 'antd';

interface IProps {
  size: number;
}

const AppLogo: React.FC<IProps> = ({ size }: IProps) => {
  return <Image height={size} src='/logo.jpg' preview={false} />;
};

export default AppLogo;
